import { GET } from "../APiHelper/API";

let source = null;

export const getFixturePrices = (onSuccess, onError) => {
  source = GET("/api/v1/fixtures/prices", onSuccess, onError, true, source);
};
